const CONTROL = 'Ctrl_FEATURE_VENMO_OVERLAY_VARIANT';
const INTERSTITIAL_WITH_RTM = 'Trmt_FEATURE_VENMO_OVERLAY_VARIANT';
const INTERSTITIAL_WITH_LOGIN = 'Trmt_FEATURE_VENMO_OVERLAY_VARIANT_2';
const HEADER = 'Trmt_FEATURE_VENMO_OVERLAY_VARIANT_3';

export const VENMO_OVERLAY_VARIANTS = {
  CONTROL,
  HEADER,
  INTERSTITIAL_WITH_LOGIN,
  INTERSTITIAL_WITH_RTM,
};
